import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import arrow from "../../assets/images/right-arrow.svg";
import loadingImage from "../../assets/images/loading.gif";

import Swal from "sweetalert2";

import "./AddLesson.css";
const AddLesson = () => {
  const history = useHistory();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [date, setDate] = useState(tomorrow);
  const [options, setOptions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log("useEffect");
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `/api/parents/options?&date=${normalizeDate(date)}`,
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        );
        setOptions(response.data);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [date]);

  const normalizeDate = (date) => {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const formatDate = (date) => {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const slots = ["00", "15", "30", "45"];

  const getHours = () => {
    console.log("hours");
    const hours = [];

    const lessonLengthUnits = options.lessonLengthUnits;
    console.log(lessonLengthUnits);

    if (options.from === 0 && options.to === 0) return hours;

    // create slots array:
    for (let i = options.from; i <= options.to; i++) {
      slots.forEach((slot) => {
        hours.push({ hour: `${i}:${slot}` });
      });
    }
    hours.push({ hour: `${options.to + 1}:00` });
    console.log(hours);

    const lessons = options.lessons.map((lesson) => lesson.HourofRide);

    console.log(lessons);

    for (let i = 0; i < hours.length; i++) {
      if (i >= hours.length - lessonLengthUnits) {
        hours[i].available = "null";
        continue;
      }
      const lessonIndex = lessons.indexOf(hours[i].hour);
      const slotTaken = lessonIndex !== -1;
      hours[i].available = slotTaken ? "taken" : "open";
      hours[i].to = slotTaken ? null : hours[i + lessonLengthUnits].hour;
      if (slotTaken) {
        const lessonSlots = options.lessons[lessonIndex].UnitsNumbers;
        for (let j = 1; j < lessonSlots; j++) {
          hours[i + j].available = "taken";
        }
        i += lessonSlots - 1;
      } else {
        let x = -1;
        for (let k = 1; k < lessonLengthUnits; k++) {
          if (!lessons.includes(hours[i + k].hour)) {
            hours[i + k].available = "open";
          } else {
            x = k;
            break;
          }
        }
        if (x !== -1) {
          // 2
          for (let d = 0; d < x; d++) {
            hours[i + d].available = "null";
          }
        }
      }
    }
    console.log(hours);
    return hours;
  };

  const getHebrewDay = (dayIndex) => {
    switch (dayIndex) {
      case 0:
        return "ראשון";
      case 1:
        return "שני";
      case 2:
        return "שלישי";
      case 3:
        return "רביעי";
      case 4:
        return "חמישי";
      case 5:
        return "שישי";
      case 6:
        return "שבת";
      default:
        return "";
    }
  };

  const addLesson = (hour) => {
    Swal.fire({
      title: "בטוח/ה ?",
      text: `השיעור יתקיים בתאריך ${normalizeDate(date)} בשעה ${hour}`,
      icon: "warning",
      confirmButtonText: "הוספת שיעור",
      showCancelButton: true,
      cancelButtonText: "ביטול",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            `/api/parents/nextLessons`,
            {
              date: formatDate(date),
              hour,
            },
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          );
          if (response.status === 201) {
            Swal.fire({
              icon: "success",
              title: "השיעור נוסף בהצלחה",
              text: `השיעור יתקיים בתאריך ${normalizeDate(date)} בשעה ${hour}`,
              confirmButtonText: "תודה",
            }).then(() => {
              history.goBack();
            });
          }
        } catch (error) {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "תקלה בהוספת שיעור",
            text: "אנא נסה שנית מאוחר יותר",
            confirmButtonText: "תודה",
          });
        }
      }
    });
  };

  const nextDay = () => {
    setDate(new Date(date.setDate(date.getDate() + 1)));
  };

  const previousDay = () => {
    setDate(new Date(date.setDate(date.getDate() - 1)));
  };

  const isAfterTomorrow = tomorrow.getDate() < date.getDate();
  console.log(tomorrow.toDateString(), date.toDateString(), isAfterTomorrow);

  if (isLoading) return <img id="loading" src={loadingImage} alt="" />;

  return (
    <div id="addLesson">
      <div>
        <div id="title">
          <img
            src={arrow}
            alt="previous"
            onClick={() => {
              history.goBack();
            }}
          />
          <h3>הוספת שיעור - שעות אפשריות</h3>
          <span id="spacer"></span>
        </div>
        <div id="date">
          <div
            style={{ opacity: isAfterTomorrow ? 1 : 0 }}
            onClick={isAfterTomorrow ? previousDay : null}
            className={`changeDayDiv`}
          >
            <img src={arrow} alt="previous" />
            <span>היום הקודם</span>
          </div>
          <span id="dateSpan">{`${date.getDate()}/${
            date.getMonth() + 1
          }/${date.getFullYear()} - ${getHebrewDay(date.getDay())}`}</span>
          <div onClick={nextDay} className="changeDayDiv">
            <span>היום הבא</span>
            <img id="next" src={arrow} alt="next" />
          </div>
        </div>
      </div>
      <hr style={{ margin: "8px 0" }} />
      {options && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "8px",
            overflowY: "auto",
            padding: "16px 0",
          }}
        >
          {options.from === 0 && options.to === 0 ? (
            <h1 style={{ textAlign: "center", margin: "36px 0" }}>
              אין שיעורים זמינים ביום זה
            </h1>
          ) : (
            getHours()
              .filter((slot) => slot.available === "open")
              .map((slot) => {
                return (
                  <div
                    key={slot.hour}
                    onClick={() => {
                      addLesson(slot.hour);
                    }}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        border: "1px solid black",
                        padding: "12px",
                        backgroundColor: "#2edb1e",
                        textAlign: "center",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          display: "inline-block",
                          width: "100px",
                        }}
                      >
                        {/* {slot.to ? ` ${slot.to} - ` : ""} */}
                        {slot.hour}
                      </span>
                    </div>
                  </div>
                );
              })
          )}
        </div>
      )}
    </div>
  );
};

export default AddLesson;
